import { AddressComponent } from './address/address.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { EditModalComponent } from './edit-modal/edit-modal.component';
import { HeaderComponent } from './header/header.component';
import { LabeledFieldComponent } from './labeled-field/labeled-field.component';
import { MultiColumnFilterComponent } from './multi-column-filter/multi-column-filter.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NavbarContentDirective } from './navbar/navbar-content.directive';
import { PanelComponent } from './panel/panel.component';
import { PopoverComponent } from './popover/popover.component';
import { JobSearchComponent } from './job-search/job-search.component';

import { SpinnerComponent } from './spinner/spinner.component';

import { OfflineBannerComponent } from './offline-banner/offline-banner.component';

import { InfoOverlayComponent } from './info-overlay/info-overlay.component';

import { VersionDisplayComponent } from './version-display/version-display.component';
import { NotificationIconComponentComponent } from './notification-icon-component/notification-icon-component.component';

import { AppsyncStatusComponent } from './appsync-status/appsync-status.component';
import { TrainingQRCodeComponent } from './training-qr-code/training-qr-code.component';

export const UI_COMPONENTS = [
  HeaderComponent,
  NavbarComponent,
  NavbarContentDirective,
  ConfirmationDialogComponent,
  JobSearchComponent,
  PopoverComponent,
  MultiColumnFilterComponent,
  LabeledFieldComponent,
  AddressComponent,
  EditModalComponent,
  PanelComponent,
  SpinnerComponent,
  OfflineBannerComponent,
  InfoOverlayComponent,
  VersionDisplayComponent,
  NotificationIconComponentComponent,
  AppsyncStatusComponent,
  TrainingQRCodeComponent,
  // CacheStatusComponent is standalone - imported separately in ui.module.ts
  // YearQuarterPickerComponent is standalone - imported separately in ui.module.ts
];

export * from './header/header.component';
export * from './navbar/navbar.component';
export * from './confirmation-dialog/confirmation-dialog.component';
export * from './job-search/job-search.component';
export * from './job-search/job-search.service';
export * from './popover/popover.component';
export * from './multi-column-filter/multi-column-filter.component';
export * from './labeled-field/labeled-field.component';
export * from './address/address.component';
export * from './edit-modal/edit-modal.component';
export * from './panel/panel.component';
export * from './spinner/spinner.component';
export * from './offline-banner/offline-banner.component';
export * from './info-overlay/info-overlay.component';
export * from './version-display/version-display.component';
export * from './notification-icon-component/notification-icon-component.component';
export * from './appsync-status/appsync-status.component';
export * from './training-qr-code/training-qr-code.component';
export * from './job-readiness-indicator/job-readiness-indicator.component';
export * from './job-readiness-indicator/job-readiness-indicator.utils';
export * from './date-filter/date-filter.component';
export * from './date-range-picker/date-range-picker.component';
export * from './date-range-picker/relative-date-range-presets.utils';
export * from './year-quarter-picker/year-quarter-picker.component';
export * from './cache-status/cache-status.component';
export * from './confirmation-dialog/confirmation-dialog.component';
export * from './layout/layout.service';
// export * from './sidebar/sidebar.component';
